import { Alert } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles(() =>
  createStyles({
    errorAlert: {
      backgroundColor: "red",
      color: "black",
    },
  })
);

const errorMsg = (
  <>
    Något gick fel, om felet består kontakta oss{" "}
    <a href="mailto:fjarrkontrollen@profu.se">här</a>
  </>
);

const GeneralErrorMessage = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof Alert>
>(function GeneralErrorMessage(props, ref) {
  const classes = useStyles();
  return (
    <Alert
      {...props}
      ref={ref}
      severity="error"
      sx={{ width: "100%" }}
      className={classes.errorAlert}
    >
      {errorMsg}
    </Alert>
  );
});

export default GeneralErrorMessage;
